// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"Loader_spinnerContainer__1iJJx","spinner":"Loader_spinner__3uOr2","spinnerContainerTransparent":"Loader_spinnerContainerTransparent__16J6e"};